import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faAddressCard, faBalanceScale, faBook, faFile, faHome, faInfoCircle, faMoon, faSignOut, faSun, faUserShield } from '@fortawesome/free-solid-svg-icons';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AuthService } from '../../services/auth.service';
import { ThemeService } from '../../services/theme.service';


const MENU_CONFIG = {
  collapsed: true,
  blocks: [
    {
      title: 'Chat',
      link: '/chat',
      permissions: 'any',
      icon: faHome,
    },
    {
      title: 'Documents',
      link: '/documents',
      permissions: 'any',
      icon: faFile,
    },
    {
      title: 'Glossary',
      link: '/glossary',
      permissions: 'any',
      icon: faBook,
    },
    {
      title: 'About',
      permissions: 'any',
      link: '/legal',
      collapsed: true,
      icon: faInfoCircle,
      children: [
        {
          title: 'Terms of use',
          link: '/legal/terms',
          permissions: 'any',
          icon: faBalanceScale,
        },
        {
          title: 'Data Policy',
          link: '/legal/data-policy',
          permissions: 'any',
          icon: faUserShield,
        },
      ],
    },
  ],
};

@Component({
  selector: 'app-navbar',
  imports: [FontAwesomeModule, RouterLink, RouterLinkActive, NgxPermissionsModule, BsDropdownModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  readonly authService = inject(AuthService);
  private themeService = inject(ThemeService);

  readonly menu = MENU_CONFIG;

  isOpen = signal(false);

  isAuthenticated = computed(() => this.authService.isAuthenticated());
  userFirstName = computed(() => this.authService.userProfile()?.firstName);
  themeIcon = computed(() => this.themeService.theme() === 'dark' ? this.sunIcon : this.moonIcon);
  themeText = computed(() => this.themeService.theme() === 'dark' ? 'Light Theme' : 'Dark Theme');

  profileIcon = faAddressCard;
  sunIcon = faSun;
  moonIcon = faMoon;
  logoutIcon = faSignOut;


  toggleNavbar() {
    this.isOpen.set(!this.isOpen());
  }
  closeNavbar() {
    this.isOpen.set(false);
  }

  logout() {
    this.authService.logout();
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }
}
